import { render, staticRenderFns } from "./SimplePagination.vue?vue&type=template&id=10308d15&scoped=true&"
import script from "./SimplePagination.vue?vue&type=script&lang=js&"
export * from "./SimplePagination.vue?vue&type=script&lang=js&"
import style0 from "./SimplePagination.vue?vue&type=style&index=0&id=10308d15&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10308d15",
  null
  
)

export default component.exports